import { useMutation, useQueryClient } from "@tanstack/react-query";

import type { components } from "@/api/types";
import { apiPatch, qk } from "@/shared/api";

type ProfileUpdate = components["schemas"]["ProfileUpdate"];

/**
 * Настройки профиля: язык и уведомления.
 *
 * `PATCH` возвращает профиль целиком, поэтому кэш заменяется через
 * `setQueryData` — инвалидация вызвала бы лишний GET за теми же данными.
 * Пустое тело контрактом допустимо, поля необязательны и независимы.
 */
export function useUpdateProfile() {
  const client = useQueryClient();

  return useMutation({
    mutationFn: (payload: ProfileUpdate) => apiPatch("/api/v1/profile", { body: payload }),
    onSuccess: (profile) => {
      client.setQueryData(qk.profile(), profile);
    },
  });
}
